<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add Client</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                      <div class="md-layout spacing">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Vendor
                        </label>
                        <div class="md-layout-item">
                          <select-input
                              v-model="client.vendor_id"
                              deselect-label="Can't remove this value"
                              track-by="id"
                              label=""
                              placeholder="Select vendors"
                              :options="vendors"
                              :allow-empty="false"
                          >
                          </select-input>
                          <validation-error :errors="apiValidationErrors.vendor_id" />
                        </div>
                      </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="client.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                redirect url
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="client.redirect" />
                                    <validation-error :errors="apiValidationErrors.redirect" />
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Client</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInput from '@/components/Inputs/SelectInput.vue';

export default {
    components: { SelectInput, ValidationError },

    mixins: [formMixin],

    data: () => ({
        vendors: [],
        client: {
            type:'clients',
            name:null,
            vendor_id:null,
            redirect: null
        }
    }),
    created () {
        this. fetchVendors();
    },
    methods: {
        async fetchVendors () {
            await this.$store.dispatch('vendors/list');
            this.vendors = this.$store.getters['vendors/dropdown'];
        },
        async add () {
            try {
                await this.$store.dispatch('clients/add',  this.client);
                this.notifySuccess('Clients added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'List Client' });
        },

    },
};
</script>
